var map = {
	"./axia/icons/patch.png": 333,
	"./boomea/boomea/icons/patch.png": 343,
	"./boomea/icons/patch.png": 362,
	"./simplifi/icons/patch.png": 375
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 872;
module.exports = webpackAsyncContext;